import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import ArticleCountsRecord from '../../records/manage/ArticleCountsRecord';
export default function articleCounts(state = new ArticleCountsRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_ARTICLE_COUNTS_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_ARTICLE_COUNTS_ERROR:
      return state.merge({
        // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
        counts: new ImmutableMap(),
        error: action.payload,
        isRequesting: false
      });
    case ActionTypes.FETCH_ARTICLE_COUNTS_SUCCESS:
      return state.merge({
        isRequesting: false,
        // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
        counts: new ImmutableMap(action.payload),
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    default:
      return state;
  }
}